export function filterByChannel() {
  return function (msg1: any, msg2: any): boolean {
    try {
      return msg1.request.channel === msg2.channel;
    } catch (e) {
      return false;
    }
  };
}
